(function () {
    'use strict';

    angular.module("imApp").factory("timeCustomersWoService", ['$ihttp', function ($ihttp) {
        let service = {
            listTimeCustomersWos: function (parms) {
                return $ihttp.post({
                    method: 1291,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
